import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Row, Select, Space, Table, Typography, message, Modal as AntModal, Col, Spin } from "antd";
import type { TableProps } from "antd";
import "./ReportFlareVocEmissionTable.css";
import { usePagination } from "src/hook/usePagination";
import { useDidMount } from "src/hook/useDidMount";
import { useShallow } from "zustand/react/shallow";
import { profileStore } from "src/stores/profile-store";
import { flareVolumeStore } from "src/stores/flare-volume-store";
import { utilsStore } from "src/stores/utils-store";
import { reportFlareStore } from "src/stores/report-flare-volume-store";
import { InfoCircleOutlined, CloseOutlined } from "@ant-design/icons";
import {
  FilterReportVocEmission,
  Month,
  ObjectSummaryForAbsolute,
  ObjectSummaryWithUnit,
  ResponseReportVocEmission,
  SummaryReportVocEmission,
  SummaryReportVocEmissionAbsolute,
  TableColumnMonthlyProps,
} from "src/entity/flare/report-voc-emission.entity";
import {
  flareCaseFilter,
  ListFlareCaseWithTotal,
  MapFlareCaseLabelToTotalValue,
  MapFlareCaseLabelToValue,
  TitleFlareCase,
} from "src/entity/flare/flare.constants";
import { excelStore } from "src/stores/excel-store.interface";
import { MonthsDisplayNoTotal, UnitAllEnum } from "src/entity/common/unit.constant";
import { TbRefresh } from "react-icons/tb";
import ModalApproveMonth from "src/components/ModalApproveMonth/ModalApproveMonth";
import { flareApproveStore } from "src/stores/flare-approve-store";
import { componentPalette } from "src/theme/component-palette";
import { BsTable } from "react-icons/bs";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { PiChartBarFill } from "react-icons/pi";
import { RolesNameEnum } from "src/entity/common/roles.enum";
import ModalApproveStep from "src/components/ModalApproveStep/ModalApproveStep";
import { useSearchParams } from "react-router-dom";
import { ApproveBody, ResponseAPI } from "src/entity/voc-approve/voc-approve.entity";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { parseFloat4Digit } from "src/utils/number";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { canApproveAndViewMainReport, canApproveAndViewTable } from "src/pages/VocsInventory/Flare/PermissionCheck/PermissionCheck";
import { getFilterWithEmptyMasterdata } from "src/utils/utils-object";
import { formatNumberWithRoundUpDecimal, parseAndFormatScientificNumber, parseToFixedDecimalWithComma } from "src/utils/process-number";
import { KeyofMonthly } from "src/entity/common/global.entity";
import { optionsSelectYears } from "src/utils/array";
import { VocEmissionReport } from "src/entity/waste-water/report-voc-emission.entity";
import Search, { SearchProps } from "antd/es/input/Search";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

const { Text } = Typography;
interface ReportFlareVocEmissionTableProps {}

const ReportFlareVocEmissionTable: React.FC<ReportFlareVocEmissionTableProps> = ({}) => {
  const menu = "flare";
  const currentYear = new Date().getFullYear();
  const [messageApi, contextHolder] = message.useMessage();

  const [searchParams, setSearchParams] = useSearchParams();
  const approveId = searchParams.get("approveId");
  const yearParam = searchParams.get("year");
  const monthParam = searchParams.get("month");
  const approveNoParam = searchParams.get("approveNo");

  const prevCompany: any = useRef();

  const [selectedYear, setSelectedYear] = useState<string>(currentYear.toString());
  const [selectedUnit, setSelectedUnit] = useState<UnitAllEnum>(UnitAllEnum.KG);
  const [openModalApproveMonth, setOpenModalApproveMonth] = useState<boolean>(false);
  const [selectedButton, setSelectedButton] = useState<string>("table");
  const [openModalApproveStep, setOpenModalApproveStep] = useState<boolean>(false);
  const [tableKey, setTableKey] = useState(0);
  const { permissions } = useNavigationMenu();

  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const userId = profile?.userId;
  const email = profile?.email;
  const name = profile?.name;

  const getTextWidth = utilsStore(useShallow((state) => state.getTextWidth));

  const getAreaInCompany = utilsStore(useShallow((state) => state.getAreaInCompany));
  const dataAreaInCompany = utilsStore(useShallow((state) => state.dataAreaInCompany));

  const setLoadingAll = flareVolumeStore(useShallow((state) => state.setLoadingAll));
  const loadingAll = flareVolumeStore(useShallow((state) => state.loadingAll));
  const getAllHeatingValue = flareVolumeStore(useShallow((state) => state.getAllHeatingValue));
  const dataHeatingValueAll = flareVolumeStore(useShallow((state) => state.dataHeatingValueAll));
  const getAllSettingFlareInformation = flareVolumeStore(useShallow((state) => state.getAllSettingFlareInformation));
  const dataFlareInfo = flareVolumeStore(useShallow((state) => state.dataFlareInfo));
  const loadingGetVoc = reportFlareStore(useShallow((state) => state.loadingGetVoc));
  const searchReportVocEmission = reportFlareStore(useShallow((state) => state.searchReportVocEmission));
  const dataReportVoc = reportFlareStore(useShallow((state) => state.dataReportVoc));
  const getFilterColumnReportVocEmission = reportFlareStore(useShallow((state) => state.getFilterColumnReportVocEmission));
  const filterReportVocEmission = reportFlareStore(useShallow((state) => state.filterReportVocEmission));

  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));
  const queryStr = excelStore(useShallow((state) => state.queryStr));
  const setQueryStringExcel = excelStore(useShallow((state) => state.setQueryStr));

  const getMonthCanApprove = flareApproveStore(useShallow((state) => state.getMonthCanApprove));
  const loadingOptionMonth = flareApproveStore(useShallow((state) => state.loading));
  const optionMonth = flareApproveStore(useShallow((state) => state.optionMonth));
  const createSubmitReportVoc = flareApproveStore(useShallow((state) => state.createSubmitReportVoc));
  const loadingSubmitVocReport = flareApproveStore(useShallow((state) => state.loadingSubmitVocReport));
  const getInfoStepApprove = flareApproveStore(useShallow((state) => state.getInfoStepApprove));
  const loadingGetApprove = flareApproveStore(useShallow((state) => state.loadingGetApprove));
  const approveData = flareApproveStore(useShallow((state) => state.approveData));
  const selectedApprove = flareApproveStore(useShallow((state) => state.selectedApprove));

  const getOptionApprove = flareApproveStore(useShallow((state) => state.getOptionApprove));
  const optionApprove = flareApproveStore(useShallow((state) => state.optionApprove));
  const updateApproveStep = flareApproveStore(useShallow((state) => state.updateApproveStep));

  // For new ui approval page
  const [selectedYearApprove, setSelectedYearApprove] = useState<number | null>();
  const [selectedMonthApprove, setSelectedMonthApprove] = useState<string | null>();
  const [selectedNoApprove, setSelectedNoApprove] = useState<number | null>();

  // For width column by content
  const [widthMainColumns, setWidthMainColumnsl] = useState<{ [key: string]: string }>({});
  const [widthTotal, setWidthTotal] = useState<string>("");
  const [widthCol, setWidthCol] = useState<{ [key: string]: string }>();

  //   console.log(" filterReportVocEmission : ", filterReportVocEmission);
  //   console.log("dataHeatingValueAll : ");

  // Text Search
  const [textSearch, setTextSearch] = useState<string>("");
  const [searchTrigger, setSearchTrigger] = useState(0);

  const fetchInfoStepApprove = async () => {
    if (selectedYearApprove && selectedMonthApprove && selectedNoApprove) {
      const query = new URLSearchParams({
        menu,
        year: selectedYearApprove.toString(),
        month: selectedMonthApprove,
        approveNo: selectedNoApprove.toString(),
      }).toString();
      getInfoStepApprove(query);
    } else {
      getInfoStepApprove("");
    }
  };
  const fetchMonthOfSubmit = async () => {
    await getMonthCanApprove(selectedYear);
  };

  const removeSarchParam = () => {
    searchParams.delete("year");
    searchParams.delete("month");
    searchParams.delete("approveNo");
    searchParams.delete("companyId");
  };

  const resetSelections = () => {
    if (yearParam && monthParam && approveNoParam) {
      handleButtonMenuClick("approve");
      if (yearParam) setSelectedYearApprove(Number(yearParam));
      if (monthParam) setSelectedMonthApprove(monthParam);
      if (approveNoParam) setSelectedNoApprove(Number(approveNoParam));
      removeSarchParam();
    } else {
      setSelectedYearApprove(null);
      setSelectedMonthApprove(null);
      setSelectedNoApprove(null);
    }
  };

  const fetchOptionVocApprove = async () => {
    if (yearParam && !selectedYearApprove && !selectedMonthApprove) return;

    const queryParams = new URLSearchParams({ menu });
    if (selectedYearApprove) {
      queryParams.append("year", selectedYearApprove.toString());
    }
    if (selectedMonthApprove) {
      queryParams.append("month", selectedMonthApprove);
    }

    const queryString = queryParams.toString();
    const approves = await getOptionApprove(queryString);
    // console.log("ApproveOption HERE : ", approves);
  };

  const {
    onChange,
    filter,
    page,
    setPage,
    loading,
    limit: pageSize,
    setLimit: setPageSize,
    data: sourceData,
    replaceFilter,
  } = usePagination<ResponseReportVocEmission, FilterReportVocEmission>({
    action: searchReportVocEmission,
    remoteData: dataReportVoc.data,
    initialFilter: { year: [selectedYear], unit: selectedUnit },
  });

  // console.log("Source data :: ", dataReportVoc);

  const handleButtonMenuClick = (buttonName: string) => {
    // console.log("on click : ", buttonName, approveId);
    setSelectedButton(buttonName);
    if (buttonName === "table") {
      setOpenModalApproveStep(false);
      if (approveId) {
        searchParams.delete("approveId");
        searchParams.delete("companyId");
        setSearchParams(searchParams);
      }
    } else if (buttonName === "approve") {
      fetchOptionVocApprove();
      setOpenModalApproveStep(true);
    }
  };

  useEffect(() => {
    if (approveId) {
      handleButtonMenuClick("approve");
    }
  }, [approveId]);

  const getMasterLabel = useCallback(
    (type: string, text: string) => {
      if (!text || typeof text != "string") return "";

      if (type === "gasName" && dataHeatingValueAll) {
        const optValue = dataHeatingValueAll.find((item) => item._id === text);
        return optValue?.gasName;
      } else if (type === "area" && dataAreaInCompany) {
        const optValue = dataAreaInCompany.find((item) => item._id === text);
        return optValue?.areaName;
      } else if (type === "flareName" && dataFlareInfo) {
        const optValue = dataFlareInfo.find((item) => item._id === text);
        return optValue?.flareName;
      } else if (type === "unit" && dataHeatingValueAll) {
        const optValue = dataHeatingValueAll.find((item) => item._id === text);
        return optValue?.unitHeatingValue;
      } else if (type === "flareCase") {
        const optValue = flareCaseFilter.find((item) => item.value === text);
        return optValue?.text;
      } else return text;
    },
    [dataFlareInfo, dataAreaInCompany, dataHeatingValueAll],
  );

  const getMainColumnsWidth = (
    fontSize = "18px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMainColumns: { [key in keyof VocEmissionReport]: string } = {} as any;
    const mainColumns = ["sourceName", "gasName", "area", "flareName", "flareCase", "emission", "unit"];
    if (sourceData && sourceData.length > 0) {
      mainColumns.forEach((column) => {
        let max = 0;

        sourceData.forEach((row) => {
          let value = row.details[column as keyof typeof row.details] ?? "";
          if (["gasName", "area", "flareName", "flareCase"].includes(column))
            value = getMasterLabel(column, row.details[column as keyof typeof row.details] as string) ?? "";

          const text = String(value);
          const textWidth = getTextWidth(text, font);
          if (textWidth > max) max = textWidth;
        });

        let labelWidth = 0;
        if (["area"].includes(column)) labelWidth = 80;
        if (max < labelWidth) max = labelWidth;

        if (max < 50) max = 100;
        widthMainColumns[column as keyof typeof widthMainColumns] = `${max * 1.1}px`;
      });
    }
    setWidthMainColumnsl(widthMainColumns);
  };

  const getWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMonth: { [key in keyof SummaryReportVocEmission]: string } = {} as any;
    const summary = dataReportVoc.summary;
    const months: Month[] = [
      { title: "Jan", dataIndex: "jan" },
      { title: "Feb", dataIndex: "feb" },
      { title: "Mar", dataIndex: "mar" },
      { title: "Apr", dataIndex: "apr" },
      { title: "May", dataIndex: "may" },
      { title: "Jun", dataIndex: "jun" },
      { title: "Jul", dataIndex: "jul" },
      { title: "Aug", dataIndex: "aug" },
      { title: "Sep", dataIndex: "sep" },
      { title: "Oct", dataIndex: "oct" },
      { title: "Nov", dataIndex: "nov" },
      { title: "Dec", dataIndex: "dec" },
    ];
    months.forEach((month) => {
      const keyMonth = month.dataIndex as keyof SummaryReportVocEmission;

      const valueOfMonth = summary?.[0]?.[keyMonth];
      let maxWidthCol = 0;

      if (valueOfMonth && typeof valueOfMonth === "object" && !Array.isArray(valueOfMonth)) {
        for (const [key, value] of Object.entries(valueOfMonth)) {
          if (["Kg", "Ton"].includes(key)) {
            const text = String(value);
            const width = getTextWidth(text, font);
            maxWidthCol = Math.max(maxWidthCol, width);
          } else if (typeof value === "object" && value !== null && !Array.isArray(value)) {
            for (const nestedValue of Object.values(value)) {
              const text = String(nestedValue);
              const width = getTextWidth(text, font);
              maxWidthCol = Math.max(maxWidthCol, width);
            }
          }
        }
      }

      if (maxWidthCol < 90) {
        maxWidthCol = 90;
      }

      widthMonth[keyMonth] = `${maxWidthCol * 1.1}px`;
    });

    setWidthCol(widthMonth);
    const widthTotalAb = summary?.[0]?.total || "";
    const widthTotalIn = summary?.[1]?.total || "";
    const textWidthTotalAb = getTextWidth(String(widthTotalAb), font);
    const textWidthTotalIn = getTextWidth(String(widthTotalIn), font);
    let maxWidthTotal = Math.max(textWidthTotalAb, textWidthTotalIn);
    if (maxWidthTotal == 0) {
      maxWidthTotal = 100;
    }
    setWidthTotal(`${maxWidthTotal * 1.1}px`);
  };

  const gasNameFilter = useMemo(() => {
    return getFilterWithEmptyMasterdata(dataHeatingValueAll, filterReportVocEmission.gasName, "gasName");
  }, [dataHeatingValueAll, filterReportVocEmission.gasName]);
  const sourceNameFilter = useMemo(() => {
    return filterReportVocEmission.sourceName.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterReportVocEmission.sourceName]);
  const areaFilter = useMemo(() => {
    return getFilterWithEmptyMasterdata(dataAreaInCompany, filterReportVocEmission.area, "areaName");
  }, [dataAreaInCompany, filterReportVocEmission.area]);
  const flareNameFilter = useMemo(() => {
    return getFilterWithEmptyMasterdata(dataFlareInfo, filterReportVocEmission.flareName, "flareName");
  }, [dataFlareInfo, filterReportVocEmission.flareName]);

  const handleTableChange: TableProps<ResponseReportVocEmission>["onChange"] = (_, filters) => {
    const mergeFilter = { ...filters, unit: selectedUnit };
    setQueryStringExcel(JSON.stringify(mergeFilter));
    onChange(mergeFilter);
  };
  const handleChangeUnit = () => {
    if (selectedUnit === UnitAllEnum.KG) {
      setSelectedUnit(UnitAllEnum.TON);
      const tmpQuery = queryStr ? { ...JSON.parse(queryStr), unit: UnitAllEnum.TON } : { unit: UnitAllEnum.TON };
      setQueryStringExcel(JSON.stringify(tmpQuery));
    } else if (selectedUnit === UnitAllEnum.TON) {
      const tmpQuery = queryStr ? { ...JSON.parse(queryStr), unit: UnitAllEnum.KG } : { unit: UnitAllEnum.KG };
      setQueryStringExcel(JSON.stringify(tmpQuery));
      setSelectedUnit(UnitAllEnum.KG);
    }
  };

  const addWidthWhenEmptyData = useCallback(
    (width: string, isForce?: string) => {
      if (dataReportVoc.data.length === 0) return { width };
      else if (isForce) return { width: isForce };
      else return {};
    },
    [dataReportVoc.data],
  );

  const monthColumns: TableProps<ResponseReportVocEmission>["columns"] = MonthsDisplayNoTotal.map((item) => {
    return {
      title: item.title,
      key: item.dataIndex,
      width: widthCol?.[item.dataIndex],
      render: (_, record) => {
        const res =
          selectedUnit === UnitAllEnum.KG
            ? record[item.dataIndex as keyof TableColumnMonthlyProps]?.freeze.vocEmissionValue ||
              record[item.dataIndex as keyof TableColumnMonthlyProps]?.vocEmissionValue
            : record[item.dataIndex as keyof TableColumnMonthlyProps]?.freeze.vocEmissionValueTon ||
              record[item.dataIndex as keyof TableColumnMonthlyProps]?.vocEmissionValueTon ||
              "0";
        return <Text className={`pr-[5rem]`}>{parseAndFormatScientificNumber(`${res}`, 2)}</Text>;
      },
      align: "left",
      // ...addWidthWhenEmptyData("3.5rem"),
    };
  });

  const columns: TableProps<ResponseReportVocEmission>["columns"] = [
    {
      title: "Source Name",
      key: "sourceName",
      render: (_, record) => <Text>{record.details.sourceName}</Text>,
      filters: sourceNameFilter,
      align: "left",
      width: widthMainColumns.sourceName,
      // ...addWidthWhenEmptyData("8rem", "8rem",),
    },
    {
      title: "Gas Name",
      key: "gasName",
      render: (_, record) => <Text>{getMasterLabel("gasName", record.details.gasName)}</Text>,
      filters: gasNameFilter,
      align: "left",
      width: widthMainColumns.gasName,
      // ...addWidthWhenEmptyData("8rem", "8rem"),
    },
    {
      title: "Area",
      key: "area",
      render: (_, record) => <Text>{getMasterLabel("area", record.details.area)}</Text>,
      filters: areaFilter,
      align: "left",
      width: widthMainColumns.area,
      // ...addWidthWhenEmptyData("8rem", "8rem"),
    },
    {
      title: "Flare Name",
      key: "flareName",
      render: (_, record) => <Text>{getMasterLabel("flareName", record.details.flareName)}</Text>,
      filters: flareNameFilter,
      align: "left",
      width: widthMainColumns.flareName,
      // ...addWidthWhenEmptyData("8rem", "10rem"),
    },
    {
      title: "Flare Case",
      dataIndex: "flareCase",
      key: "flareCase",
      render: (text) => <Text>{getMasterLabel("flareCase", text)}</Text>,
      filters: flareCaseFilter,
      align: "left",
      width: widthMainColumns.flareCase,
      // ...addWidthWhenEmptyData("8rem"),
    },
    {
      title: "Emission",
      key: "emission",
      render: (_) => <Text>TVOCs</Text>,
      align: "left",
      width: widthMainColumns.emission,
      // ...addWidthWhenEmptyData("8rem"),
    },
    {
      title: (
        <>
          <Space>
            Unit
            <Button onClick={handleChangeUnit} type="text" icon={<TbRefresh />} />
          </Space>
        </>
      ),
      key: "unit",
      render: (_) => <Text>{selectedUnit}</Text>,
      align: "left",
      width: widthMainColumns.unit,
    },
    ...monthColumns,
    {
      title: "Total",
      width: widthTotal,
      render: (_, record) => (
        <Text>
          {selectedUnit === UnitAllEnum.KG
            ? parseAndFormatScientificNumber(`${record.totalValue}`, 2)
            : parseAndFormatScientificNumber(`${record.totalValueTon}`, 2)}
        </Text>
      ),
      align: "left",
      ...addWidthWhenEmptyData("4rem"),
    },
  ];

  const initialRequestDidMount = async (isDidMount?: boolean) => {
    setLoadingAll(true);
    const getAreaInCompanyPromise = getAreaInCompany(profile?.activeCompany._id as string); // area
    const getAllSettingFlareInformationPromise = getAllSettingFlareInformation(); // flare name
    const getAllHeatingValuePromise = getAllHeatingValue(selectedYear); // gas name
    const getFilterColumnReportVocEmissionPromise = getFilterColumnReportVocEmission(selectedYear);
    const searchReportVocEmissionPromise = searchReportVocEmission(
      isDidMount === true
        ? { ...filter, page, limit: pageSize, year: [selectedYear] }
        : { page, limit: pageSize, year: [selectedYear], unit: selectedUnit },
    );

    await Promise.all([
      getAreaInCompanyPromise,
      getAllSettingFlareInformationPromise,
      getAllHeatingValuePromise,
      getFilterColumnReportVocEmissionPromise,
      searchReportVocEmissionPromise,
    ]);
    setLoadingAll(false);
  };

  useDidMount(() => {
    prevCompany.current = profile?.activeCompany._id;
    initialRequestDidMount(true);

    setQueryStringExcel(JSON.stringify({ unit: selectedUnit }));
  });

  // ** NOTE : Trigger for Request new data -> when change company, year
  useEffect(() => {
    if (profile?.activeCompany) {
      if (prevCompany.current !== profile.activeCompany._id) {
        replaceFilter({ year: [currentYear.toString()], unit: selectedUnit });
        setSelectedYear(currentYear.toString());
        setSelectedYearExcel(currentYear.toString());
        resetSelections();
        prevCompany.current = profile?.activeCompany._id;
        fetchOptionVocApprove();
      }
      setTableKey(tableKey + 1);
      setTextSearch("");
    }
  }, [profile?.activeCompany, selectedYear]);

  useEffect(() => {
    if (yearParam) {
      setSelectedYear(yearParam);
      searchParams.delete("year");
    }
  }, [yearParam]);

  useEffect(() => {
    if (tableKey > 0) {
      initialRequestDidMount(false);
      setQueryStringExcel(JSON.stringify({ unit: selectedUnit }));
      fetchOptionVocApprove();
      fetchInfoStepApprove();
    }
  }, [tableKey]);

  useEffect(() => {
    if (optionApprove && "approveNo" in optionApprove) {
      const { approveNo } = optionApprove || {};
      if (approveNo) {
        if (!selectedNoApprove && selectedYearApprove && selectedMonthApprove && approveNo?.length === 1) {
          setSelectedNoApprove(approveNo[0]);
        }
      } else {
        resetSelections();
      }
    }
  }, [optionApprove]);

  useEffect(() => {
    if (yearParam && approveNoParam) {
      handleButtonMenuClick("approve");
      if (yearParam) setSelectedYearApprove(Number(yearParam));
      if (monthParam) setSelectedMonthApprove(monthParam);
      if (approveNoParam) setSelectedNoApprove(Number(approveNoParam));
    }
  }, [yearParam, monthParam, approveNoParam]);

  useEffect(() => {
    fetchOptionVocApprove();
    fetchInfoStepApprove();
  }, [selectedYearApprove, selectedMonthApprove, selectedNoApprove]);

  useEffect(() => {
    getMainColumnsWidth();
  }, [sourceData]);

  useEffect(() => {
    getWidth();
  }, [dataReportVoc]);

  useEffect(() => {
    searchReportVocEmission({ ...filter, textSearch, page: 1, limit: pageSize, year: [selectedYear] });
  }, [searchTrigger]);

  const handleChangeYear = (year: string) => {
    // console.log("Year : ", year);
    setSelectedYearExcel(year);
    replaceFilter({ year: [year], unit: selectedUnit });
    setSelectedYear(year);
  };
  const buttonStyle = (buttonName: string) => ({
    backgroundColor: selectedButton === buttonName ? componentPalette.primary : "initial",
    color: selectedButton === buttonName ? "white" : "initial",
  });
  const handleOpenModalApproveMonth = () => {
    fetchMonthOfSubmit();
    setOpenModalApproveMonth(true);
  };

  const warningAlert = (message: string | string[], action: string) => {
    const warnModal = AntModal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not {action}</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: message,
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const handleSubmitReport = async (checkMonths: any) => {
    const userId = profile?.userId;
    const payload = {
      userId: userId as string,
      months: checkMonths,
      year: selectedYear,
    };

    createSubmitReportVoc(payload)
      .then(() => {
        setOpenModalApproveMonth(false);
        messageApi.open({
          type: "success",
          content: CommonSuccess.SUBMIT_SUCCESSFULL,
        });
      })
      .catch((error) => {
        const responseData = error?.response?.data as ResponseAPI;
        warningAlert(String(responseData.message), "submit");
        return;
      });
  };

  const handleApproveReport = async (approveBody: ApproveBody, action: string) => {
    updateApproveStep(approveBody)
      .then(() => {
        if (action === "approved") {
          messageApi.open({
            type: "success",
            content: CommonSuccess.APPROVED_SUCCESSFULL,
          });
        } else if (action === "reject") {
          messageApi.open({
            type: "success",
            content: CommonSuccess.REJECT_SUCCESSFULL,
          });
          // const findSlot = optionApprove.find((item) => item.value == approveBody.approveId);
          // const extractYear = findSlot?.label.split(" / ") as string[];

          // calculateReportAfterRejectApproval({ years: [extractYear[1]] });
        }
        fetchInfoStepApprove();
        fetchMonthOfSubmit();
      })
      .catch((error) => {
        const actionStr = action === "approved" ? "approve" : "reject";
        warningAlert(error?.response?.data?.message || error?.message, actionStr);
        return;
      });
  };

  const handleYearApproveChange = (value: number) => {
    setSelectedYearApprove(value);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const handleMonthApprovalChange = (value: string) => {
    setSelectedMonthApprove(value);
    setSelectedNoApprove(null);
  };

  const handleApproveNoChange = (value: number) => {
    setSelectedNoApprove(value);
  };

  const isDisableSubmitButton = () => {
    if (!canApproveAndViewTable(permissions) || dataReportVoc.data?.length == 0) {
      return true;
    } else {
      return false;
    }
  };

  const onSearch: SearchProps["onSearch"] = (value, _e) => {
    setTextSearch(value);
    setSearchTrigger((prev) => prev + 1);
  };

  return (
    <Row className="w-full" id={"wrap-report-flare-voc-table"}>
      {contextHolder}
      <Space direction={"horizontal"} align={"start"}>
        {selectedButton === "table" ? (
          <Select value={selectedYear} style={{ width: 120 }} onChange={handleChangeYear} options={optionsSelectYears()} size="middle" />
        ) : (
          <Space>
            <Select
              value={selectedYearApprove}
              style={{ width: 120 }}
              onChange={handleYearApproveChange}
              options={optionApprove?.year?.map((year) => ({ label: year, value: year }))}
              loading={loading}
              size="middle"
            />
            <Select
              value={selectedMonthApprove}
              style={{ width: 120 }}
              onChange={handleMonthApprovalChange}
              options={optionApprove?.month?.map((month) => ({ label: month.charAt(0).toUpperCase() + month.slice(1), value: month }))}
              loading={loading}
              size="middle"
            />
            <Select
              value={selectedNoApprove}
              style={{ width: 120 }}
              onChange={handleApproveNoChange}
              options={optionApprove?.approveNo?.map((approveNo) => ({ label: approveNo, value: approveNo }))}
              loading={loading}
              size="middle"
            />
          </Space>
        )}
        <div>
          <Button
            size="middle"
            style={buttonStyle("table")}
            icon={<BsTable style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("table")}
          />
          <Button
            size="middle"
            style={buttonStyle("chart")}
            icon={<PiChartBarFill style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("chart")}
          />
          <Button
            size="middle"
            style={buttonStyle("approve")}
            icon={<HiOutlineClipboardDocumentCheck style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("approve")}
          />
        </div>
      </Space>
      {selectedButton === "table" && (
        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
          <Search
            onSearch={onSearch}
            style={{ width: 250 }}
            value={textSearch}
            onChange={(e) => setTextSearch(e.target.value)}
            allowClear
          />
        </div>
      )}
      {selectedButton === "table" && (
        <Table
          key={tableKey}
          style={{ whiteSpace: "nowrap" }}
          columns={addCenterAlign(columns)}
          dataSource={canApproveAndViewMainReport(permissions) ? (sourceData as ResponseReportVocEmission[]) : []}
          className="w-full mt-4"
          loading={loadingProfile || loadingAll || loading || loadingGetVoc}
          rowKey={(record) => `${record._id}-${record.flareCase}`}
          scroll={{ x: "max-content", y: sourceData?.length === 0 ? "auto" : 500 }}
          pagination={false}
          onChange={handleTableChange}
          summary={(pageData) => {
            if (pageData.length > 0) {
              return (
                <Table.Summary fixed="bottom">
                  {dataReportVoc?.summary && dataReportVoc.summary.length > 0 && (
                    <>
                      {
                        <>
                          {ListFlareCaseWithTotal.map((flareCase, index) => {
                            const objectAbsolute: SummaryReportVocEmissionAbsolute = dataReportVoc.summary.find((item) =>
                              item.key.includes("VocAbsolute"),
                            ) as SummaryReportVocEmissionAbsolute;
                            return (
                              <Table.Summary.Row>
                                {flareCase === TitleFlareCase.NORMAL_OPERATE ? (
                                  <Table.Summary.Cell index={0} colSpan={4} rowSpan={4}>
                                    <div style={{ textAlign: "center" }}>
                                      <Text>VOCs Absolute</Text>
                                    </div>
                                  </Table.Summary.Cell>
                                ) : (
                                  <Table.Summary.Cell index={0} colSpan={4} className="hidden" />
                                )}

                                <Table.Summary.Cell index={1} colSpan={1}>
                                  <div style={{ textAlign: "start" }}>
                                    <Text>{flareCase}</Text>
                                  </div>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={2} colSpan={1}>
                                  <div style={{ textAlign: "start" }}>
                                    <Text>TVOCs</Text>
                                  </div>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={3} colSpan={1}>
                                  <div style={{ textAlign: "start" }}>
                                    <Text>{selectedUnit}</Text>
                                  </div>
                                </Table.Summary.Cell>

                                {/* HERE */}
                                {MonthsDisplayNoTotal.map((month, idxMonth) => {
                                  const keyMonth = month.dataIndex;
                                  const parseUnit: keyof ObjectSummaryWithUnit = selectedUnit as keyof ObjectSummaryWithUnit;
                                  const total =
                                    flareCase === TitleFlareCase.TOTAL
                                      ? (objectAbsolute[keyMonth as keyof KeyofMonthly] as ObjectSummaryWithUnit)[parseUnit]
                                      : (
                                          objectAbsolute[keyMonth as keyof KeyofMonthly][
                                            MapFlareCaseLabelToValue[
                                              flareCase as keyof typeof MapFlareCaseLabelToValue
                                            ] as keyof ObjectSummaryForAbsolute
                                          ] as ObjectSummaryWithUnit
                                        )[parseUnit];

                                  return (
                                    <>
                                      <Table.Summary.Cell index={idxMonth + index} colSpan={1}>
                                        <div style={{ textAlign: "start" }}>
                                          <Text> {total ? parseAndFormatScientificNumber(`${total}`, 2) : 0}</Text>
                                        </div>
                                      </Table.Summary.Cell>
                                    </>
                                  );
                                })}
                                <Table.Summary.Cell index={MonthsDisplayNoTotal.length} colSpan={1}>
                                  <div style={{ textAlign: "start" }}>
                                    <Text>
                                      {parseAndFormatScientificNumber(
                                        `${
                                          (
                                            objectAbsolute[
                                              MapFlareCaseLabelToTotalValue[
                                                flareCase as keyof typeof MapFlareCaseLabelToTotalValue
                                              ] as keyof SummaryReportVocEmissionAbsolute
                                            ] as ObjectSummaryWithUnit
                                          )[selectedUnit as keyof ObjectSummaryWithUnit]
                                        }`,
                                        2,
                                      )}
                                    </Text>
                                  </div>
                                </Table.Summary.Cell>
                              </Table.Summary.Row>
                            );
                          })}
                        </>
                      }
                      {dataReportVoc.summary
                        .filter((item) => item.key.includes("Intensity"))
                        .map((row, index) => {
                          // console.log("Here row :: ", row);
                          return (
                            <Table.Summary.Row>
                              <Table.Summary.Cell index={0} colSpan={6}>
                                <Col span={19}>
                                  <div style={{ textAlign: "center" }}>
                                    <Text>{row.label}</Text>
                                  </div>
                                </Col>
                              </Table.Summary.Cell>
                              <Table.Summary.Cell index={2} colSpan={1}>
                                <div style={{ textAlign: "start" }}>
                                  <Text>{row.label === "Absolute" ? selectedUnit : row.unit}</Text>
                                </div>
                              </Table.Summary.Cell>

                              {MonthsDisplayNoTotal.map((month, idxMonth) => {
                                const keyMonth = month.dataIndex;
                                const rowValue = row[keyMonth as keyof typeof row];
                                const total =
                                  typeof rowValue === "object" &&
                                  rowValue !== null &&
                                  UnitAllEnum.KG in rowValue &&
                                  UnitAllEnum.TON in rowValue
                                    ? rowValue[selectedUnit as keyof ObjectSummaryWithUnit]
                                    : (rowValue as string | number);
                                return (
                                  <>
                                    <Table.Summary.Cell index={idxMonth + index} colSpan={1}>
                                      <div style={{ textAlign: "start" }}>
                                        <Text>
                                          {" "}
                                          {total
                                            ? row.key === "VocIntensity" || row.key === "VocIntensityNormalOperate"
                                              ? parseAndFormatScientificNumber(`${total}`, 2)
                                              : parseAndFormatScientificNumber(`${total}`, 2)
                                            : 0}
                                        </Text>
                                      </div>
                                    </Table.Summary.Cell>
                                  </>
                                );
                              })}
                              <Table.Summary.Cell index={MonthsDisplayNoTotal.length} colSpan={1}>
                                <div style={{ textAlign: "start" }}>
                                  <Text>
                                    {row.key === "VocIntensity" || row.key === "VocIntensityNormalOperate"
                                      ? parseAndFormatScientificNumber(`${row.total[selectedUnit as keyof ObjectSummaryWithUnit]}`, 2)
                                      : parseAndFormatScientificNumber(`${row.total[selectedUnit as keyof ObjectSummaryWithUnit]}`, 2)}
                                  </Text>
                                </div>
                              </Table.Summary.Cell>
                            </Table.Summary.Row>
                          );
                        })}
                    </>
                  )}
                </Table.Summary>
              );
            }
          }}
        />
      )}

      {openModalApproveMonth && (
        <ModalApproveMonth
          open={openModalApproveMonth}
          intitailMonthly={optionMonth}
          loadingOption={loadingOptionMonth}
          loading={loadingSubmitVocReport}
          onSubmitReport={(checkedMonths) => {
            handleSubmitReport(checkedMonths);
          }}
          onCancelReport={() => {
            setOpenModalApproveMonth(false);
          }}
        />
      )}

      {selectedButton === "table" && (
        <Row className="w-full mt-4" justify={"end"}>
          {selectedButton == "table" && profile?.roles.includes(RolesNameEnum.COMPANY_ADMIN) && (
            <Button type="primary" style={{}} onClick={handleOpenModalApproveMonth} disabled={isDisableSubmitButton()}>
              Submit
            </Button>
          )}
        </Row>
      )}
      {openModalApproveStep && approveData && userId && selectedApprove && email && name && (
        <>
          {loadingOptionMonth || loadingGetApprove ? (
            <Row className="w-full" style={{ height: "4rem" }} justify={"center"}>
              <Spin style={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
            </Row>
          ) : (
            <>
              <div style={{ height: "4rem" }} />
              <ModalApproveStep
                data={approveData}
                userId={userId}
                approveId={selectedApprove}
                email={email}
                name={name}
                onApprove={(approveBody, action) => {
                  handleApproveReport(approveBody, action);
                }}
              />
            </>
          )}
        </>
      )}
    </Row>
  );
};

export default ReportFlareVocEmissionTable;
